export const languageOptions = [
    { value: "cpp", label: "C++" },
    { value: "c", label: "C" },
    { value: "java", label: "Java" },
    { value: "python", label: "python" },
    { value: "javascript", label: "JavaScript" },
    { value: "typescript", label: "TypeScript" },
    { value: "bash", label: "bash" },
    { value: "clojure", label: "Clojure" },
    { value: "coffeescript", label: "CoffeeScript" },
    { value: "csharp", label: "C#" },
    { value: "dart", label: "Dart" },
    { value: "elixir", label: "Elixir" },
    { value: "fsharp", label: "F#" },
    { value: "go", label: "Go" },
    { value: "julia", label: "Julia" },
    { value: "kotlin", label: "Kotlin" },
    { value: "lua", label: "Lua" },
    { value: "php", label: "PHP" },
    { value: "perl", label: "perl" },
    { value: "powershell", label: "PowerShell" },
    { value: "rscript", label: "R" },
    { value: "ruby", label: "Ruby" },
    { value: "rust", label: "Rust" },
    { value: "scala", label: "Scala" },
    { value: "swift", label: "swift" },
    { value: "basic.net", label: "VB" },
];
